import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Home from "@/views/index.vue";
import Login from "@/views/login.vue";
import HomePage from "@/views/HomePage.vue";
import OrderPage from "@/views/OrderPage.vue";
import MyPage from "@/views/MyPage.vue";
import hotGoods from "@/views/hotGoods.vue";
import hotGoodsDetails from "@/views/hotGoodsDetails.vue";
import submitOrder from "@/views/submitOrder.vue";
import Address from "@/views/Address.vue";
import orderDetails from "@/views/orderDetails.vue";
import instructions from "@/views/instructions.vue";
import questions from "@/views/questions.vue";
import AboutUs from "@/views/AboutUs.vue";
import ServiceAgreement from "@/views/ServiceAgreement.vue";
import PrivacyAgreement from "@/views/PrivacyAgreement.vue";
import Search from "@/views/Search.vue";
import Success from "@/views/Success.vue";
import logistics from "@/views/logistics.vue";
import NoPermission from "@/views/NoPermission.vue";
import { ref } from "vue";
import { getQueryString } from "@/utils";
import { getAuthUrl, getUserInfo } from "@/provide/wxConfig";
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: Home,
    redirect: "/HomePage",
    children: [
      {
        path: "/HomePage",
        name: "HomePage",
        component: HomePage,
      },
      {
        path: "/OrderPage",
        name: "OrderPage",
        component: OrderPage,
      },
      {
        path: "/MyPage",
        name: "MyPage",
        component: MyPage,
      },
    ],
  },
  {
    path: "/hotGoods",
    name: "hotGoods",
    component: hotGoods,
  },
  {
    path: "/hotGoodsDetails/:id",
    name: "hotGoodsDetails",
    component: hotGoodsDetails,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/submitOrder",
    name: "submitOrder",
    component: submitOrder,
  },
  {
    path: "/Address",
    name: "Address",
    component: Address,
  },
  {
    path: "/orderDetails/:id",
    name: "orderDetails",
    component: orderDetails,
  },
  {
    path: "/instructions",
    name: "instructions",
    component: instructions,
  },
  {
    path: "/questions",
    name: "questions",
    component: questions,
  },
  {
    path: "/AboutUs",
    name: "AboutUs",
    component: AboutUs,
  },
  {
    path: "/ServiceAgreement",
    name: "ServiceAgreement",
    component: ServiceAgreement,
  },
  {
    path: "/PrivacyAgreement",
    name: "PrivacyAgreement",
    component: PrivacyAgreement,
  },
  {
    path: "/Search",
    name: "Search",
    component: Search,
  },
  {
    path: "/NoPermission",
    name: "NoPermission",
    component: NoPermission,
  },
  {
    path: "/SuccessPay",
    name: "Success",
    component: Success,
  },
  {
    path: "/logistics/:id/:logisticsNo",
    name: "logistics",
    component: logistics,
  },
];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach(async (to, from) => {
  // 动态设置标题
  window.document.title = "";
  // (to?.meta?.title as string | undefined) || "潮小六科技";
  // 校验openid
  const code = getQueryString("code");
  const openid = localStorage.getItem("bjopenid");
  if (openid) {
    return true;
  }
  if (!code) {
    const res = await getAuthUrl();
    if (res.success) {
      location.replace(res.data);
      return false;
    } else {
      return { name: "NoPermission" };
    }
  } else {
    const res = await getUserInfo(code);
    if (res.success) {
      localStorage.setItem("bjopenid", res.data.openid);
      return true;
    }
  }
  return true;
});
export default router;
